import { css } from 'aphrodite/no-important';
import { RedButton } from 'components';
import React, { FC, useCallback, useEffect } from 'react';
import { ToolTipArrow } from 'util/icons';
import { style } from './style';

interface ToolTipProps {
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  onClickOutside?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  top?: string;
  left?: string;
  bottom?: string;
  right?: string;
}

export const ToolTip: FC<ToolTipProps> = ({ top, left, bottom, right, onClick, children, onClickOutside }) => {
  const styles = style({
    top,
    left,
    bottom,
    right,
  });

  const handleClickOutside = useCallback(() => {
    onClickOutside && onClickOutside();
  }, [onClickOutside]);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('touchend', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('touchend', handleClickOutside);
    };
  }, [handleClickOutside]);

  return (
    <div className={css(styles.container)}>
      <div className={css(styles.arrow)}>
        <ToolTipArrow />
      </div>
      <RedButton className={css(styles.btn)} onClick={onClick}>
        {children}
      </RedButton>
    </div>
  );
};
